// extracted by mini-css-extract-plugin
module.exports = {"heading":"heading-module--heading--2GD_-","secondary":"heading-module--secondary--RGwPm","center":"heading-module--center--1fpCm"};